// NPM Imports
import React, { Fragment } from "react";
import ReactDOMServer from "react-dom/server";
import Modal from "react-responsive-modal";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../revvComponents";

// Internal Imports
import { IMAGE_URLS } from "../../constants";

// Destructuring
const { documentSentConfirmation } = IMAGE_URLS;

export default function AppUpdateNotification() {
  // * MAP STATE TO PROPS SYNTAX IN HOOKS
  const store = useSelector(state => {
    const {
      appVersion: { newVersionFound, isMajorRelease, oldVersion, newVersion },
    } = state.CommonStore;
    return {
      newVersionFound,
      isMajorRelease,
      oldVersion,
      newVersion,
    };
  });

  if (store.newVersionFound) {
    // * IF ITS A MAJOR RELEASE
    if (store.isMajorRelease) {
      return (
        <Modal
          open
          onClose={() => undefined}
          center
          closeOnEsc={false}
          closeOnOverlayClick={false}
          showCloseIcon={false}>
          <div className="app-update-notification-container">
            <div className="app-update-notification-image">
              <div className="app-update-notification-text">
                <div className="app-update-notification-title">
                  Revv just got better!
                </div>
                <div className="app-update-notification-subtitle">
                  Please refresh to continue
                </div>
              </div>
              <img
                src={documentSentConfirmation}
                alt="Revv"
                className="app-update-notification-confirmation-image"
              />
            </div>
            <div className="app-update-notification-update-txt">
              We’ve updated our app to give you a faster, more efficient
              experience. Please refresh the page to get the latest version. You
              will not be able to use the app until you refresh.{" "}
              <span
                title={`Old: ${store.oldVersion} /  New: ${store.newVersion}`}>
                <FontAwesomeIcon icon={["far", "info-circle"]} />
              </span>
            </div>
            <Button
              type="four"
              onClick={() => {
                window.location = window.location;
              }}
              data-test="appupdatenotification-refresh-btn">
              Refresh
            </Button>
          </div>
        </Modal>
      );
    }

    // * IF ITS A MINOR OR A PATCH RELEASE & UPDATE NOTIFICATION DOESN'T EXISTS IN UI
    if (!document.getElementsByClassName("app-update-notification").length) {
      const notify = document.createElement("div");
      notify.classList.add("app-update-notification");
      notify.innerHTML = ReactDOMServer.renderToString(
        <div>
          A new version is available{" "}
          <span title={`Old: ${store.oldVersion} /  New: ${store.newVersion}`}>
            <FontAwesomeIcon icon={["far", "info-circle"]} />
          </span>
          <a
            href={window.location}
            data-test="refresh-btn"
            className="refresh-btn">
            Refresh
          </a>
        </div>,
      );
      document.querySelector("body").appendChild(notify);
      return true;
    }
  }

  return <Fragment />;
}
